import React, {FC, useEffect, useState} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import SgbRowComponent from "./SgbRowComponent";
import {Filter, Sorter} from "../../models/Quote";
import SGBManager from "../../service/TickManager";
import {Filters, Sorters} from "../../util/Filters";
import {SGBMarket} from "../../models/SGBMarket";

type Props = {
}

const sampleSound = "https://audio-previews.elements.envatousercontent.com/files/235857457/preview.mp3?response-content-disposition=attachment%3B+filename%3D%22TGSZM2N-old-alarm-clock.mp3%22";
const beepSound = "https://preview-downloads.customer.envatousercontent.com/files/411439579/preview.mp3?response-content-disposition=attachment;filename=40393276_beep_by_bogdansfx_preview.mp3&Expires=1984150675&Signature=Vxn0n0EVIjGAdHvlq5RWajNoKI4tngfxUW-wtNgi0tPVurA56QH8AMF1muQ0VrLBAgvq7X9W6esoYQ2tIUNpg8eMPVHlH9TRZy8O2kqPW8x8qkCofnUpfH0yJPKgCAIsxZO9wIocj0P9Lprq2epBZ3H5Jou1r8FH~q0BfXRGIRicVTSeD-G7ElIOUBTw7o4lsgPArw3Fhqq2IhAOZ2IZC-RcMAcQm89nxfSitgZu5jagFA2K-YOqXz0jIghVwSSggAziZrhZIp8yH5n0Vjjubk8i5C0vN0htfjKD8vuZE7X8kriPCDYJdjrzaAa8kIT-qOW1kp3mx-~BDEB0YsMgmjnbY627sQV97pgTRRLARugdXef2-bFspUaKOywFW6ng9zveoxpdsrB5P8hWRmL1koC5~rwOTEyCdvH2TwsZN6bZwPya1HqH2pqvJ7zPAka0hf3DU1Q9Wkb0VRi3-rd2y32pcb17OcXiaxKjjhu3YKZI~bs5~uS-hXqBt9bNA6GF1Rs25Z0YssOVCkOXuIdhs54mo7AZBpV8VpXUleyAHwEKcbG4FSj3ZO8qCJLBP6IFKSsexE0UaWDOG4Zy2WFU2fzT6b5Ah40iWjpORG6SFWvHPYJYzpcX6mjRE3rTfEV2VRdSZ6Y2nR7sHgLbvVwGn9~uDIFdfWfGrQ4r9p9ZmFc_&Key-Pair-Id=APKAJRP2AVKNFZOM4BLQ";

//https://audiojungle.net/search/congratulation
const congratulation = "https://preview-downloads.customer.envatousercontent.com/files/392024796/preview.mp3?response-content-disposition=attachment;filename=37708893_teenage-girl-say-congratulations-pack_by_kazoomx_preview.mp3&Expires=1967904575&Signature=rKTzUi50~NqKUqrIyVUc8av~A0bl7Jb5wY4rEQSHO-ot0luZVPi2e3Q3dJl4ZOQL4BZVWBsSw~QD6KjlFGMxIvjsmtwnsVjODCKsYnp2HxkUzORgyO-t3XGOFoVYM6jY7j6odVcS4mGNUyO2N-9JDE8Qxxb9BcpCpfY-5h1XaZW-EIY418ESRhEwYd8UFpTo8qBCJccZ0FN0tNjGEq51mEimwmzD9W5U7a9SxTo6BZ3aFewqnzSJ8t88UlpChmsuGZpZVVhKHkkqPEtEDQslrnca4qzsb~4FlH8yBDvgXSescu~PUSbUKxLbhrFYzS7uFTW2qNgQKcI8sLNm-IYwFP-y3KmH7zgetlXqtGEeiUmaDxaiKPhTVd4Yxm4F2YmUOfsNAdrOqY5y0c1As9oflC15xZzSLw7oQBIA0-gmNfB5VheUN76SPor1ESQ1THPdBIrf~0qIra7El212Xu1BuaibQxkEM9k4qmEJQiaubLzW7u1932zw9KBOJ8d1D6uXGA9GbZv2BrFncBdBhyX0WnFabqCRz~k~u4dfNcjaS9RzeBesp0jX9GKZ3cU2PUqpS8OLp1y-FHc2142Qbg0SsnvZM6o3c1jODLn~F59uM68lbHs7Q1uU7Nur8-278LWs8VTUtn0WFryFnSSmyJ1SA8wtQPualq9uW72iRkFIW94_&Key-Pair-Id=APKAJRP2AVKNFZOM4BLQ";
// const congratulation = "https://drive.google.com/file/d/1AIkjwVSkj9t0ZKmMjglhWMI1K7rApLcA/view?usp=sharing";
const audio = new Audio(sampleSound);
const congo = new Audio(congratulation);
const beep = new Audio(beepSound);
let _filters = new Set<Filter>();
_filters.add(Filters.defaultFilter);


const TableComponent: FC<Props> = () => {

    const [_sgbs, setSgbs] = useState<Array<SGBMarket>>([]);
    const[flag, setFlag] = useState(false);
    const[sorter, _setSorter] = useState<Sorter>(()=>Sorters.monthsToRedeem);
    const[filters, _setFilter] = useState(_filters);
    const[isAsc, setAsc] = useState(true);
    const[pause] = useState(false);
    const[isNotificationPaused, IsNotificationPaused] = useState<boolean>(false);
    const[client, setClient] = useState(localStorage.getItem("client") || "complex");
    let isComplex = client==='complex';
    function notifications(opportunity:string){
        if(opportunity==='congo'){
            congo.play();//FIXME:
        }else if(opportunity==="beep" && !isNotificationPaused){
            beep.play();
        }else if(opportunity!=="none" && !isNotificationPaused){
            console.error(opportunity);
        }
    }
    SGBManager.setOpportunityHook(notifications);
    function toggleClient():void {
        if(client==="complex"){
            localStorage.setItem("client", "simple");
            setClient("simple");
        }else{
            localStorage.setItem("client", "complex");
            setClient("complex");
        }
    }
    useEffect(()=>{
        if(isNotificationPaused){
            audio.pause();congo.pause();
        }
    }, [isNotificationPaused])


    useEffect(()=>{
        SGBManager.setPause(pause);
    }, [pause])
    useEffect(()=>{
        SGBManager.subscribe((data:Array<SGBMarket>)=>{
            setSgbs(data);
            setFlag(!flag);
        });
    }, [])

    function setFilter(param: Filter, clear:boolean = false) {
        if(clear)filters.clear()
        if(filters.has(param)){
            filters.delete(param);
        }else {
            filters.add(param);
        }
        SGBManager.setFilter(filters)
        _setFilter(new Set(filters));    }

    function setSorter(param: ()=>Sorter) {
        _setSorter(param);
        setAsc(!isAsc);
    }
    let filter = Array.from(filters.values()).reduce((a,b) => sgb => a(sgb) && b(sgb));
    const sgbs = _sgbs.filter(filter).sort(Sorters.createNew(sorter, isAsc));

    function clearFilter() {
        const f = new Set<Filter>();
        f.add(Filters.defaultFilter);
        _setFilter(f);
        SGBManager.setFilter(f)
        setFlag(!flag);
    }



    return <div>

        <div className={"full"}>
            <button onClick={()=> clearFilter()}>clear ({sgbs.length})</button>
            <button onClick={()=> setFilter(Filters.NO_BID, true)}> no bid  </button>
            <button onClick={()=> setFilter(Filters.TRADED_TODAY)}> traded today  </button>
            <button onClick={()=> setFilter(Filters.PROFITABLE_LOW)}> profitable low </button>
            <button onClick={()=> setFilter(Filters.LessThan6)}> {"<6 "}  </button>
            <button onClick={()=> setFilter(Filters.LessThan12)}> {"<12 "}  </button>
            {/*<button onClick={()=> setFilter(Filters.LessThan18)}> {"<18  "}  </button>*/}
            <button onClick={()=> setFilter(Filters.LessThan24)}> {"<24 "}  </button>
            <button onClick={()=> setFilter(Filters.AUTO, true)}>AUTO</button>
            {/*<button onClick={()=> setFilter(Filters.ProfitableSeller)}>onlyProfitable seller</button>*/}
            <button onClick={()=> setFilter(Filters.profitAverageTP)}>profitable with average tp</button>
            <button onClick={()=> setFilter(Filters.MyBids, true)}>Mine</button>
            <button onClick={()=> setFilter(Filters.Holding, true)}>holding</button>
            <button onClick={()=> toggleClient()}>toggle client</button>
            {/*<button onClick={()=> setFilter(Filters.holdingECA, true)}>holding eca</button>*/}
            {/*<button onClick={()=> setFilter(Filters.holdingICT, true)}>holding ict</button>*/}
            <button onClick={()=>IsNotificationPaused(!isNotificationPaused)}>{isNotificationPaused? "resume" : "pause"} notiications</button>
            {/*<button onClick={()=>congo.play()}>test congo</button>*/}
            {/*<button onClick={()=>hurry.play()}>test hurry</button>*/}
        </div>

        <table className={"full"}>
            <thead>
            <tr>
                <th>name</th>
                <th onClick={()=> {setSorter(()=>Sorters.monthsToRedeem);}}>months</th>
                <th onClick={()=> {setSorter(()=>Sorters.PROFITABLE);}}>profitable</th>
                <th onClick={()=> {setSorter(()=>Sorters.buyer);}}>bid</th>
                <th onClick={()=> {setSorter(()=>Sorters.bidYTM);}}>ytm</th>
                <th onClick={()=> {setSorter(()=>Sorters.profitableDiff);}}>diff</th>
                <th onClick={()=> {setSorter(()=>Sorters.myBid);}}>mine</th>
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.low)}}>low</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.volume);}}>volume</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.atp)}}>average</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.ltt)}}>time</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.last_price)}}>last_price</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.profitableSellerDiff);}}>s diff</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.seller);}}>buy</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.buyYTM);}}>ytm</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.couponVal);}}>coupon</th>:<></>}
                {isComplex?<th onClick={()=> {setSorter(()=>Sorters.days);}}>days</th>:<></>}
                <th>force</th>
            </tr>
            </thead>
            <tbody>
            {sgbs.map(sgb => <SgbRowComponent
                key = {sgb.sgb.genInfo.tradingsymbol}
                market = {sgb}
                isComplex={isComplex}
            />)}
            </tbody>
        </table>
    </div>;
}

export default TableComponent;